import { NavLink } from "react-router-dom";
import { Bell } from "lucide-react";
import { RAIL_ICON, RAIL_SLOT } from "@/components/layout/sidebar-rail";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useUnreadNotificationCount } from "@/hooks/use-notifications";
import { cn } from "@/lib/utils";

export function NotificationBell({ to }: { to: string }) {
  const { data: unread } = useUnreadNotificationCount();
  const hasUnread = !!unread && unread > 0;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <NavLink
          to={to}
          aria-label={hasUnread ? `Notifications (${unread} unread)` : "Notifications"}
          className={cn("relative", RAIL_SLOT)}
        >
          <Bell className={RAIL_ICON} strokeWidth={1.75} />
          {hasUnread && (
            <span
              aria-hidden
              className="absolute right-2.5 top-2.5 h-2 w-2 rounded-full bg-brand ring-2 ring-background"
            />
          )}
        </NavLink>
      </TooltipTrigger>
      <TooltipContent side="right">
        {hasUnread ? `Notifications (${unread} unread)` : "Notifications"}
      </TooltipContent>
    </Tooltip>
  );
}
